import { useState, useEffect } from 'react';
import { MENU_ITEMS } from '../../values/navigation';
import { handleSmoothScroll } from '../../utils/scroll';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Prevenir scroll cuando el menú está abierto en mobile
  useEffect(() => {
    if (menuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuOpen]);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
    setDropdownOpen(false); // Cerrar dropdown al abrir/cerrar menú
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setDropdownOpen(!dropdownOpen);
  };

  const handleMenuClick = (e, item) => {
    if (item.smooth) {
      handleSmoothScroll(e, item.href);
    }
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  const closeMenu = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <>
      {/* Overlay para cerrar menú mobile */}
      {menuOpen && <div className="menu-overlay" onClick={closeMenu}></div>}
      
      <header className="fixed-top">
        <div className="container">
          <div className="row">
            {/* Logo */}
            <div className="col-md-3 col-logo">
              {/* <div className="logo-text" style={{fontFamily: 'Montserrat', fontWeight: 400, fontSize: 21}}>YO LAS ENVIO</div> */}
              <div className="logo-text">Tambien Acepto</div>

              {/* Botón menú mobile */}
              <button 
                id="boton-menu-mobile" 
                onClick={toggleMenu}
                aria-label={menuOpen ? 'Cerrar menú' : 'Abrir menú'}
                aria-expanded={menuOpen}
              >
                <i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'}`}></i>
              </button>
            </div>

            {/* Menu */}
            <div className={`col-md-7 col-menu ${menuOpen ? 'open' : ''}`}>
              <ul id="menu" className="menu">
                {MENU_ITEMS.map((item) => (
                  <li key={item.id} className={item.isDropdown ? `nav-item dropdown submenu-invitaciones ${dropdownOpen ? 'open' : ''}` : ''}>
                    {item.isDropdown ? (
                      <>
                        <button
                          className="dropdown-toggle"
                          onClick={toggleDropdown}
                          aria-haspopup="true"
                          aria-expanded={dropdownOpen}
                        >
                          {item.label} <i className={`fas fa-chevron-${dropdownOpen ? 'up' : 'down'}`} style={{fontSize: '0.8rem', marginLeft: '5px'}}></i>
                        </button>
                        <div className="dropdown-menu">
                          {item.items.map((subItem, idx) => (
                            <a
                              key={idx}
                              className="dropdown-item"
                              href={subItem.href}
                              target="_blank"
                              rel="noopener noreferrer"
                              onClick={closeMenu}
                            >
                              {subItem.label}
                            </a>
                          ))}
                        </div>
                      </>
                    ) : (
                      <a
                        href={item.href}
                        className={item.smooth ? 'smoth-scroll' : ''}
                        onClick={(e) => handleMenuClick(e, item)}
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
